import React, { useState } from "react";
import { SummaryInfoBlock } from "./components/SummaryInfoBlock/SummaryInfoBlock";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { fetchItemDetails } from "./services/itemDetails.service";
import ReactSplit from "@devbookhq/splitter";
import { PdfViewer } from "./components/PdfViewer/PdfViewer";

export const DetailsPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { regulator } = useParams<{ regulator: string }>();
  const [isResizing, setIsResizing] = useState(false);
  const [panelSizes, setPanelSizes] = useState([40, 60]);
  const [fileUrl, setFileUrl] = useState<string | null>(null);

  const { data: document, isLoading } = useQuery({
    queryKey: ["document", id],
    queryFn: () => fetchItemDetails(regulator, id),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });

  if (isLoading) return <div className="line-loader"></div>;

  const handleResizeFinished = (sizes: number[]) => {
    setIsResizing(false);
    setPanelSizes(sizes);
  };

  return (
    <div className="h-[calc(100vh-80px)]">
      <ReactSplit
        initialSizes={panelSizes}
        onResizeStarted={() => setIsResizing(true)}
        onResizeFinished={(_, newSizes: number[]) =>
          handleResizeFinished(newSizes)
        }
        gutterClassName="w-3 bg-gray-400 dark:bg-black"
        draggerClassName="bg-gray-600 dark:bg-gray-300"
      >
        <SummaryInfoBlock
          data={document}
          onFetchedLink={(url) => setFileUrl(url)}
        />

        <div
          className={`w-full h-full flex items-center justify-center bg-[#262730] ${
            isResizing ? "pointer-events-none" : ""
          }`}
        >
          <PdfViewer fileUrl={fileUrl ?? document?.file_url} />
        </div>
      </ReactSplit>
    </div>
  );
};
